import { actualizarDepartamentoMunicipioService } from './actualizar-departamento-municipio.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { BehaviorSubject, map, Observable, of, Subject, switchMap } from 'rxjs';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { environment as env } from 'environments/environments';
import { FichaRegistro } from 'app/models/fichaRegistro.model';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BuscadorGestionesComponent } from 'app/modules/SharedEntitiesComponents/buscador-gestiones/buscador-gestiones.component';
import { DataTiposGestionesBienesCulturales, ResponseTiposGestionesBienesCulturales } from '../../tabs/documentos-emitidos/models/gestiones-bienes-culturales';
import { DocumentosEmitidosService } from '../../tabs/documentos-emitidos/documentos-emitidos.service';
import { ActualizarDepartamentoMunicipio } from '../models/actualizar-departamento-municipio.model';
import { UtilsService } from 'app/modules/utils-service';

@Component({
    selector: 'form-actualizar-departamento-municipio',
    templateUrl: 'actualizar-departamento-municipio.component.html',
    imports:[
        FormsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,

        BuscadorGestionesComponent,
    ]
})

export class FormActualizarDepartamentoMunicipioComponent implements OnInit {
    tipology_departamentos:number= env.TIPOLOGIA_ID_DEPARTAMENTOS
    datosActualizados: ActualizarDepartamentoMunicipio = new ActualizarDepartamentoMunicipio
    fichaRegistro:FichaRegistro
    cambioNoRegistro: boolean= false

    filterDepartamento$ = new BehaviorSubject<string>('');
    allDepartamentos: Tipologia[] = [];
    departamentos$: Observable<Tipologia[]>;

    filterMunicipios$ = new BehaviorSubject<string>('');
    allMunicipios: Tipologia[] = [];
    municipios$: Observable<Tipologia[]>;

    departamentoActual:Tipologia
    municipioActual:Tipologia

    listaGestiones: DataTiposGestionesBienesCulturales[] = [];
    gestionesSeleccionadasPadre: DataTiposGestionesBienesCulturales[] = [];

    constructor(
        public dialogRef: MatDialogRef<FormActualizarDepartamentoMunicipioComponent>,
        private documetosEmitidosService: DocumentosEmitidosService,
        private actualizarDepartamentoMunicipioService: actualizarDepartamentoMunicipioService,
        private detalleBienesService: DetalleBienCulturalService,   
        private utilsService: UtilsService,     
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: FichaRegistro
    ) {
        this.getDepartamentos()
        this.getTiposGestionesBines()
        this.fichaRegistro= this.data
     }

    ngOnInit() {
        
    }

    getTiposGestionesBines(){
        this.documetosEmitidosService.getGestionesByBienesCulturales()
            .then((response:ResponseTiposGestionesBienesCulturales)=>{
                this.listaGestiones= response.data
            })
    }

    getDepartamentos() {
    this.detalleBienesService.getTipologias(this.tipology_departamentos).then((response: Tipologia[]) => {
        this.allDepartamentos = response;

        // Precarga si existe valor en fichaRegistro.departamento.tipologiaId
        const idDepto = this.fichaRegistro?.departamento?.tipologiaId;
        if (idDepto) {
            const deptoEncontrado = this.allDepartamentos.find(d => d.tipologiaId === idDepto);
        if (deptoEncontrado) {
            this.departamentoActual = deptoEncontrado;
             this.getMunicipios(this.departamentoActual);
        }
        }

        this.departamentos$ = this.filterDepartamento$.pipe(
        switchMap(query =>
            of(this.allDepartamentos).pipe(
            map(departamentos =>
                departamentos.filter(d =>
                d.descripcion.toLowerCase().includes(query.toLowerCase())
                )
            )
            )
        )
        );
    });
    }

          
    getMunicipios(event: Tipologia) {
        this.detalleBienesService.getTipologias(event.tipologiaId).then((response: Tipologia[]) => {
            this.allMunicipios = response;

            //Limpia el municipio actual antes de precargar
            this.municipioActual = null;

            //Precarga solo si el municipio pertenece a este nuevo listado
            const idMunicipio = this.fichaRegistro?.municipio?.tipologiaId;
            if (idMunicipio) {
            const municipioEncontrado = this.allMunicipios.find(m => m.tipologiaId === idMunicipio);
            if (municipioEncontrado) {
                this.municipioActual = municipioEncontrado;
            }
            }

            this.municipios$ = this.filterMunicipios$.pipe(
            switchMap(query =>
                of(this.allMunicipios).pipe(
                map(municipios =>
                    municipios.filter(m =>
                    m.descripcion.toLowerCase().includes(query.toLowerCase())
                    )
                )
                )
            )
            );
        });
    }

    postActualizacion(){
        this.datosActualizados.nuevoDepartamento= this.departamentoActual
        this.datosActualizados.nuevoMunicipio= this.municipioActual
        this.datosActualizados.gestionesUuid = this.gestionesSeleccionadasPadre.map(g => g.gestionUuid)
        this.datosActualizados.cambioNoRegistro = this.cambioNoRegistro
        this.datosActualizados.bienCulturalUuid = this.fichaRegistro.bienCulturalUuid
        this.actualizarDepartamentoMunicipioService.postActualizacionDepartamentoMunicipio(this.datosActualizados)
        .then((response:any)=>{
            this.dialogRef.close(false)
            this.detalleBienesService.getFichaRegistro(this.fichaRegistro.bienCulturalUuid),
            this.utilsService.openSuccessSnakBar(response.message)
        })
    }



    displayFnMunicipio(municipio: Tipologia): string {
      return municipio ? municipio.descripcion : '';
    }

    displayFnDepartamento(departamento: Tipologia): string {
      return departamento ? departamento.descripcion : '';
    }
}